export var StockStatusEnum;
(function (StockStatusEnum) {
    StockStatusEnum["InStock"] = "InStock";
    StockStatusEnum["FewLeftInStock"] = "FewLeftInStock";
    StockStatusEnum["OutOfStock"] = "OutOfStock";
    StockStatusEnum["NotAvailable"] = "NotAvailableInYourArea";
})(StockStatusEnum || (StockStatusEnum = {}));
export default StockStatusEnum;
//# sourceMappingURL=stockStatusEnum.js.map